<div class="page-center">
  <p-card class="otp-card text-center" header="Verify Authenticator">
    <p>Enter the 6-digit code from your authenticator app</p>
    <div class="otp-container">
      <div class="otp-inputs">
        <input *ngFor="let digit of otpArray; let i = index; trackBy: trackByIndex" #otpInput type="text"
          inputmode="numeric" maxlength="1" class="otp-box" [value]="digit" (input)="onInput(i, $event)"
          (keydown)="onKeyDown(i, $event)" (paste)="onPaste($event)" />
      </div>
      <div><a class="btn text-primary" (click)="goTo()">Authentication Setup</a></div>
    </div>
  </p-card>
</div>